import jQuery from 'jquery'
import 'slick-carousel'

export default class GroupCarousel {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)
    this.slider = jQuery('.s-group-carousel__items', this.$element)

    this.slider.slick({
      dots: true,
      arrows: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    })
  }
}
